export default __webpack_public_path__ + "static/media/success_tick.f8eb9eb4.svg";